import { WidgetViewExtension } from '@blocksuite/std';
import { literal, unsafeStatic } from 'lit/static-html.js';

import { HIVE_TOOLBAR_WIDGET } from './toolbar';

export * from './toolbar';

export const toolbarWidget = WidgetViewExtension(
  'hive:page',
  HIVE_TOOLBAR_WIDGET,
  literal`${unsafeStatic(HIVE_TOOLBAR_WIDGET)}`
);
